import React, { useEffect, useState } from 'react';
import {
  Breadcrumbs,
  Link,
  Typography,
} from '@material-ui/core';
import { Home } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import { Route } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import translations, { defaultLanguage } from '../../languages/i18n';

import { breadcrumbNameMapsMultilingual } from '../../utils/constants';

// Per aplicar els estils del Link de material-ui al Link de react-router-dom
const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));

export default function BreadCrumb({ role, home, lang }) {
  const classes = useStyles();

  const [breadcrumbNameMap, setBreadcrumbNameMap] = useState({});

  const getCurrentUserRole = () => {
    const clinician = new RegExp(/^\/clinician\/*/g);
    const admin = new RegExp(/^\/admin\/*/g);
    if (clinician.test(window.location.pathname)) return 'clinician';
    if (admin.test(window.location.pathname)) return 'admin';
    return 'patient';
  };

  // Si no ens arriba cap role, vol dir que s'ha refrescat la pàgina, per evitar un undefined en obtenir breadcrumbNameMap
  // agafam el role de la barra d'adreces del navegador
  const userRole = !role ? getCurrentUserRole() : role;

  useEffect(() => {
    // Carregam el mapa del breadCrumb corresponent al rol de l'usuari
    // En cas de que no ens arribi cap idioma, per evitar error, ho mostram en l'idioma per defecte
    setBreadcrumbNameMap(breadcrumbNameMapsMultilingual[lang || defaultLanguage][userRole]);
  },
  [lang]);

  return (
    <Route>
      {({ location }) => {
        const pathnames = location.pathname.split('/').filter((x) => x);
        // Filtram el pathnames per a només quedar-nos amb les rutes que estan mapejades
        // Si no està mapejat no el mostrarem al breadCrumb
        // Faig tot això per a no mostrar el id del pacient, programa, ... al breadCrumb quan soc a les pantalles d'edició
        const filteredPathnames = [];
        pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          if (breadcrumbNameMap[to] !== undefined && breadcrumbNameMap[to]) {
            filteredPathnames[index] = to;
          }
        });
        return (
          <Breadcrumbs aria-label='breadcrumb'>
            <LinkRouter color='inherit' to={`/${userRole}/${home}`} className={classes.link}>
              <Home className={classes.icon} />
              {translations['_home']}
            </LinkRouter>
            {filteredPathnames.map((value, index) => {
              const last = index === filteredPathnames.length - 1;
              // Dins value hi ha to
              return last ? (
                // Si és el darrer, no ho mostrarm com un enllaç
                <Typography color='textPrimary' key={value}>{breadcrumbNameMap[value]}</Typography>
              ) : (
                <LinkRouter color='inherit' to={value} key={value}>{breadcrumbNameMap[value]}</LinkRouter>
              );
            })}
          </Breadcrumbs>
        );
      }}
    </Route>
  );
}

// Indica i controla els props que se han de passar al component
BreadCrumb.propTypes = {
  home: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};
